export const PROJECT_SCHEMA = 'iqexpo-project'
export const ELEMENT_SCHEMA = 'iqexpo-element'

export const TOPOLOGIES = [
  { id: 'straight', label: 'Prosta' },
  { id: 'l-left', label: 'L-lewe' },
  { id: 'l-right', label: 'L-prawe' },
  { id: 'u', label: 'U' },
  { id: 'island', label: 'Wyspa' },
]

export const ELEMENT_TYPES = {
  wall: { label: 'Ściana', price: 1240, width: 1.5, depth: 0.1, height: 2.5, color: '#f8fafc', shape: 'panel', mode: 'floor' },
  counter: { label: 'Lada', price: 2890, width: 1.6, depth: 0.65, height: 1.05, color: '#c89f73', shape: 'box', mode: 'floor' },
  table: { label: 'Stolik', price: 1180, width: 0.9, depth: 0.9, height: 0.76, color: '#f8fafc', shape: 'cylinder', mode: 'floor' },
  chair: { label: 'Krzesło', price: 590, width: 0.55, depth: 0.55, height: 0.84, color: '#f8fafc', shape: 'box', mode: 'floor' },
  screen: { label: 'Ekran', price: 2450, width: 1.45, depth: 0.08, height: 0.82, color: '#111827', shape: 'panel', mode: 'floor', elevation: 1.52 },
  plant: { label: 'Roślina', price: 380, width: 0.55, depth: 0.55, height: 1.05, color: '#2f7d54', shape: 'cylinder', mode: 'floor' },
  hanging: { label: 'Konstrukcja podwieszana', price: 6400, width: 3.5, depth: 2.5, height: 0.3, color: '#94a3b8', shape: 'frame', mode: 'suspended', elevation: 3.35 },
}

export const COLOR_OPTIONS = [
  { label: 'Biały', value: '#f8fafc' },
  { label: 'IQ Blue', value: '#2563eb' },
  { label: 'Dąb jasny', value: '#c89f73' },
  { label: 'Czarny ekran', value: '#111827' },
  { label: 'Srebro', value: '#94a3b8' },
  { label: 'Grafit', value: '#27313f' },
  { label: 'Zieleń', value: '#2f7d54' },
]

const initialElements = [
  { id: 'counter-1', type: 'counter', x: -1.1, z: 1.05, rotation: 0, width: 1.6, depth: 0.65, height: 1.05, color: '#c89f73', price: 2890, mode: 'floor' },
  { id: 'table-1', type: 'table', x: 1.1, z: 0.25, rotation: 0, width: 0.9, depth: 0.9, height: 0.76, color: '#f8fafc', price: 1180, mode: 'floor' },
  { id: 'chair-1', type: 'chair', x: 0.65, z: 0.95, rotation: 25, width: 0.55, depth: 0.55, height: 0.84, color: '#f8fafc', price: 590, mode: 'floor' },
  { id: 'chair-2', type: 'chair', x: 1.55, z: 0.85, rotation: -28, width: 0.55, depth: 0.55, height: 0.84, color: '#f8fafc', price: 590, mode: 'floor' },
  { id: 'screen-1', type: 'screen', x: 0, z: -1.84, rotation: 0, width: 1.45, depth: 0.08, height: 0.82, elevation: 1.52, color: '#111827', price: 2450, mode: 'floor' },
  { id: 'plant-1', type: 'plant', x: -1.75, z: -1.45, rotation: 0, width: 0.55, depth: 0.55, height: 1.05, color: '#2f7d54', price: 380, mode: 'floor' },
]

export const DEFAULT_PROJECT = {
  version: 2,
  name: 'Stoisko A-14',
  topology: 'u',
  dimensions: { width: 5, depth: 4, height: 2.5 },
  elements: initialElements,
  customElements: [],
  surfaceGraphics: {},
}

export function createElement(type, index, dimensions, customDefinition = null) {
  const def = customDefinition ?? ELEMENT_TYPES[type]
  const item = {
    id: `${type}-${Date.now()}-${index}`,
    type: customDefinition ? 'custom' : type,
    definitionId: customDefinition?.id,
    name: customDefinition?.name,
    shape: def.shape ?? 'box',
    mode: def.mode ?? 'floor',
    x: (index % 3) * 0.55 - 0.55,
    z: 0.55 + Math.floor(index / 3) * 0.5,
    rotation: 0,
    width: def.width,
    depth: def.depth,
    height: def.height,
    elevation: def.elevation ?? (def.mode === 'suspended' ? dimensions.height + 0.8 : 0),
    color: def.color,
    price: def.price ?? 0,
    graphics: def.graphics && typeof def.graphics === 'object' ? structuredClone(def.graphics) : {},
  }
  return constrainElement(item, dimensions)
}

export function normalizeProject(source) {
  if (!source || typeof source !== 'object') throw new Error('Nieprawidłowy format projektu.')
  const dimensions = {
    width: Number(source.dimensions?.width) || 5,
    depth: Number(source.dimensions?.depth) || 4,
    height: Number(source.dimensions?.height) || 2.5,
  }
  const elements = Array.isArray(source.elements) ? source.elements.map((item, index) => {
    const def = ELEMENT_TYPES[item.type] ?? {}
    return constrainElement({
      ...item,
      id: item.id || `imported-${Date.now()}-${index}`,
      type: item.type || 'custom',
      shape: item.shape ?? def.shape ?? 'box',
      mode: item.mode ?? def.mode ?? 'floor',
      width: Number(item.width) || def.width || 1,
      depth: Number(item.depth) || def.depth || 0.5,
      height: Number(item.height) || def.height || 1,
      elevation: Number(item.elevation ?? def.elevation ?? 0),
      rotation: Number(item.rotation) || 0,
      color: item.color || def.color || '#94a3b8',
      price: Number(item.price ?? def.price ?? 0),
      graphics: item.graphics && typeof item.graphics === 'object' ? item.graphics : {},
      x: Number(item.x) || 0,
      z: Number(item.z) || 0,
    }, dimensions)
  }) : []
  return {
    version: 2,
    name: String(source.name || 'Importowany projekt'),
    topology: TOPOLOGIES.some((item) => item.id === source.topology) ? source.topology : 'u',
    dimensions,
    elements,
    customElements: Array.isArray(source.customElements) ? source.customElements.map(normalizeDefinition) : [],
    surfaceGraphics: source.surfaceGraphics && typeof source.surfaceGraphics === 'object' ? source.surfaceGraphics : {},
  }
}

export function normalizeDefinition(definition) {
  if (!definition || typeof definition !== 'object') throw new Error('Nieprawidłowy format elementu.')
  const mode = definition.mode === 'suspended' ? 'suspended' : 'floor'
  return {
    id: definition.id || `custom-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    name: String(definition.name || 'Własny element'),
    shape: ['box', 'cylinder', 'panel', 'frame', 'ring'].includes(definition.shape) ? definition.shape : 'box',
    mode,
    width: Math.max(0.1, Number(definition.width) || 1),
    depth: Math.max(0.05, Number(definition.depth) || 0.5),
    height: Math.max(0.05, Number(definition.height) || 1),
    elevation: Math.max(0, Number(definition.elevation) || (mode === 'suspended' ? 3.2 : 0)),
    color: definition.color || '#94a3b8',
    price: Math.max(0, Number(definition.price) || 0),
    graphics: definition.graphics && typeof definition.graphics === 'object' ? definition.graphics : {},
  }
}

export function constrainElement(item, dimensions) {
  const rotation = ((Number(item.rotation) || 0) * Math.PI) / 180
  const width = Math.max(0.1, Number(item.width) || 0.1)
  const depth = Math.max(0.05, Number(item.depth) || 0.05)
  const halfX = Math.abs(Math.cos(rotation)) * width / 2 + Math.abs(Math.sin(rotation)) * depth / 2
  const halfZ = Math.abs(Math.sin(rotation)) * width / 2 + Math.abs(Math.cos(rotation)) * depth / 2
  const limitX = Math.max(0, dimensions.width / 2 - halfX - 0.06)
  const limitZ = Math.max(0, dimensions.depth / 2 - halfZ - 0.06)
  const elevation = item.mode === 'suspended' ? Math.max(dimensions.height + 0.25, Number(item.elevation) || dimensions.height + 0.8) : Number(item.elevation) || 0
  return { ...item, width, depth, elevation, x: Math.max(-limitX, Math.min(limitX, Number(item.x) || 0)), z: Math.max(-limitZ, Math.min(limitZ, Number(item.z) || 0)) }
}

export function getElementLabel(item) {
  return item?.name || ELEMENT_TYPES[item?.type]?.label || 'Własny element'
}

export function getElementPrice(item) {
  return Number(item?.price ?? ELEMENT_TYPES[item?.type]?.price ?? 0)
}

export function definitionFromItem(item) {
  return normalizeDefinition({ name: getElementLabel(item), shape: item.shape ?? ELEMENT_TYPES[item.type]?.shape, mode: item.mode ?? ELEMENT_TYPES[item.type]?.mode, width: item.width, depth: item.depth, height: item.height, elevation: item.elevation, color: item.color, price: getElementPrice(item), graphics: item.graphics })
}

export function calculateTotal(project) {
  const { width, depth } = project.dimensions
  const floor = width * depth * 185
  const wallLength = { straight: width, 'l-left': width + depth, 'l-right': width + depth, u: width + depth * 2, island: 0 }[project.topology]
  const structure = wallLength * 510
  const equipment = project.elements.reduce((sum, item) => sum + getElementPrice(item), 0)
  return Math.round(floor + structure + equipment)
}

export function structuralWallCount(topology) {
  return { straight: 1, 'l-left': 2, 'l-right': 2, u: 3, island: 0 }[topology] ?? 0
}

export function formatPrice(value) {
  return new Intl.NumberFormat('pl-PL').format(value)
}
